import { IPublication } from 'src/types/menu.types';
import { IPublishDestination } from '../../../components/PublishModal/types';
import { getVenuesToPublishTo } from '../getVenuesToPublishTo/getVenuesToPublishTo';
import { IGetVenuesResponseData } from 'src/api/getVenues/types';
import { IntegrationType } from '../../../constants';

export const getExternalSystemsVenuesStatuses = (
  menuPublicationStatus: IPublication | undefined,
  venues: IGetVenuesResponseData[] = [],
  isTrial: boolean,
): IPublishDestination[] => {
  const deliveryChannels = new Map<string, string>();
  venues.forEach((venue) => {
    venue.external_identifiers
      ?.filter((identifier) => identifier.external_system_integration_type === IntegrationType.DELIVERY_SERVICE)
      .forEach((identifier) => deliveryChannels.set(identifier.external_system_id, identifier.external_system_name));
  });

  return Array.from(deliveryChannels.entries()).map(([channelId, channelName]): IPublishDestination => {
    const aggregator = menuPublicationStatus?.aggregators.find((aggregator) => aggregator.aggregatorId === channelId);
    return {
      channel_id: channelId,
      name: channelName,
      ...(aggregator && {
        publicationStatus: aggregator.publicationStatus,
        publicationDate: aggregator.publicationDate,
      }),
      venues: getVenuesToPublishTo(venues, channelId, aggregator, isTrial),
    };
  });
};
